import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-glow" />
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <span className="brand-infinity">&#8734;</span>
              <h3>Kutloano Mkhulisi</h3>
            </div>
            <p className="footer-desc">
              Writer and founder of Strength in Sisterhood.
              Exploring the human experience through words that move, challenge, and inspire.
            </p>
          </div>

          <div className="footer-col">
            <h4>Explore</h4>
            <Link to="/books">Books</Link>
            <Link to="/poems">Poetry</Link>
            <Link to="/stories">Short Stories</Link>
            <Link to="/about">About</Link>
          </div>

          <div className="footer-col">
            <h4>Community</h4>
            <Link to="/forum">Forum</Link>
            <Link to="/login">Sign In</Link>
            <span className="social-link">Instagram</span>
            <span className="social-link">Twitter</span>
          </div>

          <div className="footer-col">
            <h4>Newsletter</h4>
            <p className="newsletter-text">Get updates on new releases and writings.</p>
            <div className="newsletter-form">
              <input type="email" placeholder="Your email" className="newsletter-input" />
              <button className="newsletter-btn">Subscribe</button>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Kutloano Mkhulisi. All rights reserved.</p>
          <p className="footer-tagline">Under the Infinity Banner &#8734;</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
